<template>
  <div>
    <div class="container">
      <div class="header">
        <span style="cursor: pointer" @click="$router.push('/')"><i class="el-icon-arrow-left"></i>返回首页</span>
        <h3 style="font-size: 28px">网校名师</h3>
        <span></span>
      </div>
      <div class="content">
        <el-row :gutter="20">
          <el-col :span="8" v-for="(item,index) in teacherList" :key="index"><div style="height: 238px;border: 1px solid #2D2D2D;border-radius: 4px;padding: 20px">
            <div style="display: flex;align-items: center">
              <img style="width: 72px;height: 72px;border-radius: 50%;" :src="item.teacherLogo" alt="">
              <span style="font-size: 20px;font-weight: 400;color: #1F1F1F;margin-left: 20px">{{ item.teacherName }}</span>
            </div>
            <div>
              <p>{{item.teacherIntroduce}}</p>
            </div>
          </div></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "index",
  data() {
    return {
      teacherList: []
    }
  },
  mounted() {
    this.getTeacherList()
  },
  methods: {
    getTeacherList() {
      api.teacher().then(res => {
        console.log(res.data.list)
        this.teacherList = res.data.list
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 20px auto;
  padding: 0 20px 20px;
  background: #ffffff;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
